<template>
  <div class="corp-cert-apply overflowHidden">
    <myheader :backIntercept="true" @childBackEvent="back" :headTitle="titleObj[formData.applyType].title"></myheader>
    <div class="header_extend_main" style="height: 100%;padding-bottom: 4rem;">
      <div class="header_extend_back"></div>
      <div class="header_extend_content_height vertical_flex">
        <div class="flex1" style="overflow:auto;">
          <div class="all_tips_content_card_padding8">
            <div class="all_tips_red_after ">企业名称</div>
            <div class="all_van_field">
              <van-field readonly v-model="formData.corpName" type="text" placeholder="企业名称"></van-field>
            </div>
            <div class="all_tips_red_after margin_top_5">统一社会信用代码</div>
            <div class="all_van_field">
              <van-field readonly v-model="formData.creditCode" type="text" placeholder="企业统一社会信用代码"></van-field>
            </div>
            <div class="all_tips_red_after margin_top_5">企业注册经营地址</div>
            <div class="all_van_field">
              <van-field v-model="formData.registerAddress" type="text" clearable
                placeholder="请输入企业注册经营地址，包括省市县区镇村"></van-field>
            </div>
            <div class="all_tips_red_after margin_top_5">证书类型</div>
            <div class="all_van_field">
              <van-radio-group v-model="formData.isUkeyCert">
                <van-radio :name="false">移动证书</van-radio>
                <van-radio :name="true">Ukey证书</van-radio>
              </van-radio-group>
            </div>
            <div class="all_tips_red_after margin_top_5">邮寄地址</div>
            <div class="all_van_field">
              <van-field clearable v-model="formData.holderData.holderAddress" type="text" placeholder="请输入邮寄地址"></van-field>
            </div>
            <!--             新办0 续签2 变更1  补办3  取消4-->
            <template v-if="formData.applyType === 1 || formData.applyType === 3">
              <div class="all_tips_red_after margin_top_5">{{ formData.applyType === 1 ? '变更原因' : '补办原因' }}</div>
              <div class="all_van_field">
                <van-field clearable v-model="formData.applyMemo" type="text"
                  :placeholder="`请输入${formData.applyType === 1 ? '变更原因' : '补办原因'}`"></van-field>
              </div>
            </template>
          </div>
          <div class="all_tips_content_card_padding8 margin_top_5">
            <div class="all_tips_red_after margin_top_5">办理人【<span style="color:red;">{{ $store.state.loginInfo.staffName }}</span>】的身份证</div>
            <van-radio-group v-model="blridCart">
              <van-radio :name="1">原件照片</van-radio>
              <van-radio :name="2">复印件</van-radio>
            </van-radio-group>
            <div v-show="blridCart === 1" class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="applierFrontFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('applierFrontFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('applierFrontFileId')">
                  <img v-show="applierFrontFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-front.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证正面</div>
              </div>
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="applierBackFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('applierBackFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('applierBackFileId')">
                  <img v-show="applierBackFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-back.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证反面</div>
              </div>
            </div>
            <div v-show="blridCart === 2" class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="applierCopyFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('applierCopyFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('applierCopyFileId')">
                  <img v-show="applierCopyFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-copy.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证复印件</div>
              </div>
            </div>
          </div>
          <div class="all_tips_content_card_padding8 margin_top_5">
            <div class="all_tips_red_after margin_top_5">企业营业执照</div>
            <div class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="licenseFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('licenseFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('licenseFileId')">
                  <img v-show="licenseFileId.length === 0" style="width: 5rem;height: 5rem;object-fit: contain;"
                    src="@/assets/images/cert-yyzz.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_5">点击上传清晰且完整的营业执照</div>
              </div>
            </div>
          </div>
          <div class="all_tips_content_card_padding8 margin_top_5">
            <div class="all_tips_red_after">法人身份证照片</div>
            <van-radio-group v-model="frBlridCart">
              <van-radio :name="1">原件照片</van-radio>
              <van-radio :name="2">复印件</van-radio>
            </van-radio-group>
            <div v-show="frBlridCart === 1" class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="legalFrontFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('legalFrontFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('legalFrontFileId')">
                  <img v-show="legalFrontFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-front.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证正面</div>
              </div>
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="legalBackFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('legalBackFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('legalBackFileId')">
                  <img v-show="legalBackFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-back.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证反面</div>
              </div>
            </div>
            <div v-show="frBlridCart === 2" class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader accept="image/*" v-model="legalCopyFileId" :before-read="beforeRead"
                  :after-read="(file) => afterRead('legalCopyFileId', file)" preview-size="5rem"
                  @delete="onDeleteImg('legalCopyFileId')">
                  <img v-show="legalCopyFileId.length === 0" style="width: 5rem; height: 5rem;"
                    src="@/assets/images/cert-copy.svg">
                </van-uploader>
                <div class="text12 textcolor333 margin_top_1">点击上传有效期内身份证复印件</div>
              </div>
            </div>
          </div>
          <div v-if="formData.authFileId" class="all_tips_content_card_padding8 margin_top_5">
            <div class="all_tips_red_after margin_top_5">授权书</div>
            <div class="flex-row margin_top_5">
              <div class="flex1 flex-column flex-align-center">
                <van-uploader disabled accept="image/*" :deletable="false" v-model="authFileId" preview-size="5rem">
                  <img v-show="authFileId.length === 0" style="width: 5rem;height: 5rem;object-fit: contain;"
                    src="@/assets/images/cert-sqs.svg">
                </van-uploader>
              </div>
            </div>
            <div class="tip text12">办理人必须与委托书中被授权人保持一致</div>
          </div>
          <div class="all_tips_content_card_padding8 margin_top_5">
            <div class="all_tips_red_after ">持有人姓名</div>
            <div class="all_van_field">
              <van-field v-model="formData.holderData.holderName" readonly is-link type="text" placeholder="请选择持有人"
                clearable @click="onShowHolderPopup"></van-field>
            </div>
            <div class="all_tips_red_after margin_top_5">印章类型</div>
            <div class="all_van_field">
              <van-field  v-model="formData.holderData.signetTypeName" readonly is-link type="text" placeholder="请选择印章类型"
                clearable @click="onShowSignetTypePopup"></van-field>
            </div>
            <div class="all_tips_red_after margin_top_5">印章名称</div>
            <div class="all_van_field">
              <van-field v-model="formData.holderData.signetName" readonly is-link type="text" placeholder="请选择印章名称"
                clearable @click="onShowSignetPopup"></van-field>
            </div>
          </div>
        </div>
        <div class="all_tips_bottom_card">
          <button class="all_button22 width_100 text16 bmain_active" @click="onSubmit">提交</button>
        </div>
      </div>
    </div>
    <van-popup class="popup-box" v-model:show="isShowHolderName" position="bottom">
      <div class="popup-list-box">
        <div class="popup-list-title text14" @click.stop>选择持有人</div>
        <div class="horizontal_line"></div>
        <div class="popup-list-content">
          <template v-for="item in holderData">
            <div class="popup-list-item backgroundC_white bwhite_ative display_flex"
              @click="onSelectItem(item, 'holder')">
              <div class="text14 textcolor333 ">{{ item.holderName }}</div>
            </div>
            <div class="horizontal_line"></div>
          </template>
        </div>
        <van-empty v-show="holderData.length === 0" description="暂无数据" />
      </div>
      <div style="height:.5rem;background-color: #ededed;"></div>
      <div class="cancel-btn" @click="isShowHolderName = false">
        取&nbsp;消
      </div>
    </van-popup>
    <van-popup class="popup-box" v-model:show="isShowSignetType" position="bottom">
      <div class="popup-list-box">
        <div class="popup-list-title text14" @click.stop>选择印章类型</div>
        <div class="horizontal_line"></div>
        <div class="popup-list-content">
          <template v-for="item in signetTypesData">
            <div class="popup-list-item backgroundC_white bwhite_ative display_flex"
              @click="onSelectItem(item, 'signetType')">
              <div class="text14 textcolor333 ">{{ item.signetTypeName }}</div>
            </div>
            <div class="horizontal_line"></div>
          </template>
        </div>
        <van-empty v-show="signetTypesData.length === 0" description="暂无数据" />
      </div>
      <div style="height:.5rem;background-color: #ededed;"></div>
      <div class="cancel-btn" @click="isShowSignetType = false">
        取&nbsp;消
      </div>
    </van-popup>
    <van-popup class="popup-box" v-model:show="isShowSignet" position="bottom">
      <div class="popup-list-box">
        <div class="popup-list-title text14" @click.stop>选择印章类型</div>
        <div class="horizontal_line"></div>
        <div class="popup-list-content">
          <template v-for="item in signetData">
            <div class="popup-list-item backgroundC_white bwhite_ative display_flex"
              @click="onSelectItem(item, 'signet')">
              <div class="text14 textcolor333 ">{{ item.signetName }}</div>
            </div>
            <div class="horizontal_line"></div>
          </template>
        </div>
        <van-empty v-show="signetData.length === 0" description="暂无数据" />
      </div>
      <div style="height:.5rem;background-color: #ededed;"></div>
      <div class="cancel-btn" @click="isShowSignet = false">
        取&nbsp;消
      </div>
    </van-popup>
  </div>
</template>

<script>
import { closeCurrentPage } from '../../utils/nativeOtherOperate.js'
import {
  Field,
  RadioGroup,
  Radio,
  Uploader,
  Empty, Dialog,
} from 'vant';

export default {
  components: {
    [Field.name]: Field,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Uploader.name]: Uploader,
    [Empty.name]: Empty,
  },
  data() {
    return {
      titleObj: { //新办new  续签renewal 变更change  补办reissue  取消cancel
        0: {
          title: '企业CA证书新办申请',
          stepTitle: '填写新办申请'
        },
        1: {
          title: '企业CA证书变更申请',
          stepTitle: '填写变更申请'
        },
        2: {
          title: '企业CA证书续签申请',
          stepTitle: '填写续签申请'
        },
        3: {
          title: '企业CA证书补办申请',
          stepTitle: '填写补办申请'
        },
        4: {
          title: '企业CA证书注销申请',
          stepTitle: '填写注销申请'
        },
      },
      formData: {
        corpId: '',//企业id
        corpName: '',
        certId: '',//证书id
        applyType: '', //申请类型  新办0 续签2 变更1  补办3  取消4
        creditCode: '',
        applierFrontFileId: '', //办理人身份证正面
        applierBackFileId: '', //办理人身份证背面
        applierCopyFileId: '',//办理人复印件
        licenseFileId: '', //企业营业执照
        legalFrontFileId: '', //法人正面照
        legalBackFileId: '', //法人反面照
        legalCopyFileId: '', //法人复印件
        authFileId: '',//授权书
        isUkeyCert: false, //默认移动证书
        applyMemo: '',//补办原因
        holderData: {
          holderAddress:'',//邮寄地址
          holderName: '',
          holderUserName: '',
          holderId: '',
          signetTypeName: '',
          signetName: '',
          signetId: '',
          signetType: '',
        }
      }, //提交的数据
      corpData: {}, //企业数据
      imageLimitSize: 524288,
      applierFrontFileId: [], //办理人身份证正面
      applierBackFileId: [], //办理人身份证背面
      applierCopyFileId: [],//办理人复印件
      licenseFileId: [], //企业营业执照
      legalFrontFileId: [], //法人正面照
      legalBackFileId: [], //法人反面照
      legalCopyFileId: [], //法人复印件
      authFileId: [],//授权书
      isShowHolderName: false, //是否显示持有人弹框
      isShowSignetType: false, //是否显示印章类型弹框
      isShowSignet: false, //是否显示印章列表弹框
      holderData: [],//持有人列表
      signetTypesData: [],//印章类型
      signetData: [],//印章列表
      blridCart: 1, //办理人身份证
      frBlridCart: 1, //法人身份证
      editData: {},//接口获取的编辑信息
      disabledApplyType:[2,3], //禁用的类型  新办0 续签2 变更1  补办3  取消4
    }
  },
  created() {
    this.formData.applyType = Number(this.$route.query.applyType)
    this.formData.corpId = this.$route.query.corpId
    this.formData.certId = this.$route.query.certId
  },
  mounted() {
    this.querySelectHolders(); //获取持有人列表
    this.getSignetTypes(); //获取证书类型列表
    if (this.formData.certId) { //代表编辑
      this.editInit()
    } else {
      this.init();
    }
  },
  methods: {
    //初始化
    init() {
      this.getCorpInfo();
      this.$store.dispatch(this.$LoadShow, true)
      this.$get("/cert/api/getMyCorps").then((res) => {
        this.corpLists = []
        if (res.success) {
          const data = res.data || []
          const result = data.filter(item => item.corpId === this.formData.corpId)
          if (result && result.length > 0) {
            this.corpData = result[0] || {}
            this.formData.corpId = this.corpData.corpId
            this.formData.corpName = this.corpData.corpName
            this.formData.creditCode = this.corpData.creditCode
            this.formData.legalPerson = this.corpData.legalPerson //法人姓名
          }
        } else {
          this.$Toast(res.message || res.messageDetail)
        }
      }).finally(() => {
        this.$store.dispatch(this.$LoadShow, false)
      })
    },
    editInit() { //编辑
      const params = {
        certId: this.formData.certId,
      }
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/cert/api/getEditCertApply', params).then((rel) => {
        if (rel.success) {
          this.editData = rel.data || {}
          this.formData = {
            applyId: this.editData.applyId,
            applyType: this.formData.applyType,
            corpId: this.editData.corpId,
            corpName: this.editData.corpName,
            creditCode: this.editData.creditCode,
            registerAddress: this.editData.registerAddress,
            isUkeyCert: this.editData.isUkeyCert,
            applyMemo: this.editData.applyMemo, //补办原因或者申请原因
            applierFrontFileId: this.editData.applierFrontFileId,
            applierBackFileId: this.editData.applierBackFileId,
            applierCopyFileId: this.editData.applierCopyFileId,
          }
          if (this.editData.items && this.editData.items.length > 0) {
            this.formData.holderData = this.editData.items[0] || {}
            this.formData.holderData.signetTypeName = this.editData.items[0].signetTypeText
          }
          if (this.editData.applierFrontFileId || this.editData.applierBackFileId) {
            this.blridCart = 1 //身份证
            this.getBase64('applierFrontFileId', this.formData.applierFrontFileId)
            this.getBase64('applierBackFileId', this.formData.applierBackFileId)
          } else if (this.editData.applierCopyFileId) {
            this.blridCart = 2 //复印件
            const flieArr = this.editData.applierCopyFileName ? this.editData.applierCopyFileName.split('.') : [] //根据.分割数组
            const suffix = flieArr[flieArr.length - 1] //取最后一个
            if (suffix.toLocaleLowerCase() !== 'pdf') {
              this.getBase64('applierCopyFileId', this.formData.applierCopyFileId)
            } else {
              this.applierCopyFileId = [
                {
                  file: {
                    name: this.editData.applierCopyFileName,
                    isImage: false
                  }
                }
              ]
            }
          }
          this.onSetData(this.editData)
        } else {
          this.$Toast(rel.message || rel.messageDetail)
        }
      }).finally(() => {
        this.$store.dispatch(this.$LoadShow, false)
      })
    },
    getCorpInfo() { //获取企业信息
      const params = {
        corpId: this.formData.corpId
      }
      this.$get('/corp/api/getCorpInfo', params).then(rel => {
        if (rel.success && rel.data) {
          const data = rel.data || {}
          this.onSetData(data)
        } else {
          this.$Toast(rel.message || rel.messageDetail)
        }
      })
    },
    onSetData(data) { //处理数据
      this.formData.licenseFileId = data.licenseFileId //营业执照
      this.formData.legalFrontFileId = data.legalFrontFileId //法人正面照
      this.formData.legalBackFileId = data.legalBackFileId //法人反面照
      this.formData.legalCopyFileId = data.legalCopyFileId //法人复印件
      this.formData.authFileId = data.authFileId //授权书
      if (this.formData.licenseFileId) {
        this.getBase64('licenseFileId', this.formData.licenseFileId)
      }
      if (this.formData.legalFrontFileId) {
        this.frBlridCart = 1
        this.getBase64('legalFrontFileId', this.formData.legalFrontFileId)
      }
      if (this.formData.legalBackFileId) {
        this.frBlridCart = 1
        this.getBase64('legalBackFileId', this.formData.legalBackFileId)
      }
      if (this.formData.legalCopyFileId) {
        this.frBlridCart = 2
        const flieArr = data.legalCopyFileName ? data.legalCopyFileName.split('.') : [] //根据.分割数组
        const suffix = flieArr[flieArr.length - 1] //取最后一个
        if (suffix.toLocaleLowerCase() !== 'pdf') {
          this.getBase64('legalCopyFileId', this.formData.legalCopyFileId)
        } else {
          this.legalCopyFileId = [
            {
              file: {
                name: data.legalCopyFileName,
                isImage: false
              }
            }
          ]
        }
      }
      if (this.formData.authFileId) {
        const flieArr = data.authFileName ? data.authFileName.split('.') : [] //根据.分割数组
        const suffix = flieArr[flieArr.length - 1] //取最后一个
        if (suffix.toLocaleLowerCase() !== 'pdf') {
          this.getBase64('authFileId', this.formData.authFileId)
        } else {
          this.authFileId = [
            {
              file: {
                name: data.authFileName,
                isImage: false
              }
            }
          ]
        }
      }
    },
    //获取文件base64
    getBase64(flag, fileId) {
      if (!this.Tool.isNoEmpty(fileId)) {
        return
      }
      this.$store.dispatch(this.$LoadShowLevel, true)
      this.$get('/file/api/getBase64?fileId=' + fileId).then((res) => {
        this.$store.dispatch(this.$LoadShowLevel, false)
        if (res.success && res.data) {
          let base64 = 'data:image/png;base64,' + res.data
          this[flag] = [
            { url: base64, isImage: true }
          ]
        }
      })
    },
    querySelectHolders() { //获取当前企业的持有人
      this.holderData = []
      return new Promise((resolve, reject) => {
        const params = {
          pageParams: {
            current: 1,
            size: 200,
          },
          corpId: this.formData.corpId, //企业ID
          staffStatus: 2, //已认证
        }
        this.$post('/cert/api/querySelectHolders', params).then(rel => {
          if (rel.success) {
            const data = rel.data || {}
            this.holderData = data.records || []
            resolve(true)
          } else {
            this.$Toast(res.message || res.messageDetail)
            resolve(false)
          }
        }).finally(() => {
          resolve(false)
        })
      })
    },
    getSignetTypes() { //获取印章类型
      this.signetTypesData = []
      return new Promise((resolve, reject) => {
        this.$get('/corp/api/getSignetTypes').then(rel => {
          if (rel.success) {
            this.signetTypesData = rel.data || []
            resolve(true)
          } else {
            this.$Toast(rel.message || rel.messageDetail)
            resolve(false)
          }
        }).finally(() => {
          resolve(false)
        })
      })
    },
    //读取文件前
    beforeRead(file) {
      console.log(file)
      if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/jpg') {
        this.$Toast('请选择图片文件');
        return false;
      }
      return true
    },
    onDeleteImg(type) { //删除图片
      this.formData[type] = ''
    },
    afterRead(type, file) { //文件上传完毕后会触发after-read回调函数
      console.log(type, file);
      file.status = 'uploading';
      file.message = '上传中...';
      if (file.file.size > this.imageLimitSize) {
        this.$store.dispatch(this.$LoadShow, true)
        this.Tool.compressImage(file, this.imageLimitSize, false).then((res) => {
          this.uploadBase64(type, file, res)
          this.$store.dispatch(this.$LoadShow, false)
        }).catch(err => {
          console.log(type, '该图片不支持压缩', err)
          this.uploadBase64(type, file, file.content)
          this.$store.dispatch(this.$LoadShow, false)
        })
      } else {
        this.uploadBase64(type, file, file.content)
      }
    },
    //上传营业执照，身份证正反面
    uploadBase64(flag, file, data) {
      this.$post('/file/api/saveBase64?resId=' + this.Tool.generateUUID(), {
        base64Data: data,
        clearBg: false,
        fileName: file.file.name
      }).then((res) => {
        if (res.success && res.data) {
          file.status = 'success';
          file.message = '上传成功';
          if (flag === 'licenseFileId' || flag === 'legalFrontFileId' || flag === 'legalBackFileId') {
            this.getOcrInfo(flag, res.data.fileId)
          }
          this.formData[flag] = res.data.fileId
        } else {
          file.status = 'failed';
          file.message = '上传失败';
        }
      }).catch(err => {
        console.log('/file/api/saveBase64', err)
      })
    },
    //获取ocr信息
    getOcrInfo(type, fileId) {
      this.$store.dispatch(this.$LoadShow, true)
      this.$get('/file/api/getOcr?fileId=' + fileId, {}).then(rel => {
        if (rel.success) {
          if (type === 'licenseFileId' && rel.data && rel.data.type === 'businessLicense') {
            if (this.formData.legalPerson && rel.data.map.legalPerson && this.formData.legalPerson !== rel.data.map.legalPerson) {
              this.$Toast("营业执照法人姓名和身份证姓名不一致！");
            }
            this.formData.corpName = rel.data.map.corpName
            this.formData.creditCode = rel.data.map.creditCode
            this.formData.legalPerson = rel.data.map.legalPerson
          } else if (type === 'legalFrontFileId' && rel.data && rel.data.type === 'idCard') {
            if (!rel.data.map.address) {
              this.$Toast("请上传法人身份证人像面图片！");
              return
            }
            if (this.formData.legalPerson && rel.data.map.name && this.formData.legalPerson !== rel.data.map.name) {
              this.$Toast("身份证姓名和营业执照法人姓名不一致！");
            }
            if (!this.formData.legalPerson) {
              this.formData.legalPerson = rel.data.map.name
            }
          } else if (type === 'legalBackFileId' && rel.data && rel.data.type === 'idCard') {
            if (!rel.data.map.signingAuthority) {
              this.$Toast("请上传法人身份证国徽面图片！");
            }
          }
        }
      }).finally(() => {
        this.$store.dispatch(this.$LoadShow, false)
      })
    },
    async onShowHolderPopup() { //打开选择持有人弹框
      if(this.disabledApplyType.includes(this.formData.applyType) ){
        return
      }
      if (this.holderData.length === 0) {
        const result = await this.querySelectHolders()
        if (result) {
          this.isShowHolderName = true
        }
      } else {
        this.isShowHolderName = true
      }
    },
    onSelectItem(item, type) { //弹框选择后
      switch (type) {
        case 'holder':
          this.formData.holderData.holderName = item.holderName
          this.formData.holderData.holderUserName = item.holderUserName
          this.formData.holderData.holderId = item.holderId
          this.isShowHolderName = false
          break;
        case 'signetType':
          this.formData.holderData.signetType = item.signetType
          this.formData.holderData.signetTypeName = item.signetTypeName
          this.formData.holderData.signetId = ''
          this.formData.holderData.signetName = ''
          this.isShowSignetType = false
          break;
        case 'signet':
          this.formData.holderData.signetId = item.signetId
          this.formData.holderData.signetName = item.signetName
          this.isShowSignet = false
          break;
      }
    },
    async onShowSignetTypePopup() { //打开印章类型弹框
      if(this.disabledApplyType.includes(this.formData.applyType) ){
        return
      }
      if (this.signetTypesData.length === 0) {
        const result = await this.getSignetTypes()
        if (result) {
          this.isShowSignetType = true
        }
      } else {
        this.isShowSignetType = true
      }
    },
    getSignet() { //获取当前类型下的印章列表
      this.signetData = []
      return new Promise((resolve, reject) => {
        const params = {
          corpId: this.formData.corpId,
          signetId: '',
          signetType: this.formData.holderData.signetType,
        }
        this.$store.dispatch(this.$LoadShow, true)
        this.$get('/corp/api/getValidSignets', params).then(rel => {
          if (rel.success) {
            this.signetData = rel.data || []
            resolve(true)
          } else {
            this.$Toast(rel.message || rel.messageDetail)
            resolve(false)
          }
        }).catch(() => {
          resolve(false)
        }).finally(() => {
          this.$store.dispatch(this.$LoadShow, false)
        })
      })
    },
    async onShowSignetPopup() { //显示印章名称
      if(this.disabledApplyType.includes(this.formData.applyType) ){
        return
      }
      if (!this.formData.holderData.signetType) {
        this.$Toast('请先选择印章类型！')
        return
      }
      const result = await this.getSignet();
      if (result) {
        this.isShowSignet = true
      }
    },
    back() {    // 返回
      if (this.$route.query.appCode) {
        closeCurrentPage()
      } else {
        this.$router.go(-1)
      }
    },
    onCheck() { //校验
      if (!this.formData.registerAddress) {
        this.$Toast('请输入企业注册经营地址！')
        return
      }
      if (!this.formData.holderData.holderAddress) {
        this.$Toast('请输入邮寄地址！')
        return
      }
      if ((this.formData.applyType === 1 || this.formData.applyType === 3) && !this.formData.applyMemo) {
        this.$Toast(`请输入${this.formData.applyType === 1 ? '变更原因' : '补办原因'}！`)
        return
      }
      if (this.blridCart === 1) {
        if (!this.formData.applierFrontFileId) {
          this.$Toast('请上传办理人身份证正面图片！')
          return
        }
        if (!this.formData.applierBackFileId) {
          this.$Toast('请上传办理人身份证反面图片！')
          return
        }
        this.formData.applierCopyFileId = ''
      } else if (this.blridCart === 2) {
        if (!this.formData.applierCopyFileId) {
          this.$Toast('请上传办理人身份证复印件！')
          return
        }
        this.formData.applierFrontFileId = ''
        this.formData.applierBackFileId = ''
      }
      if (!this.formData.licenseFileId) {
        this.$Toast('请上传企业营业执照图片！')
        return
      }
      if (this.frBlridCart === 1) { //如果是法人原件
        if (!this.formData.legalFrontFileId || !this.formData.legalBackFileId) {
          this.$Toast('请上传法人身份证正反面照片')
          return
        }
        this.formData.legalCopyFileId = ''
      } else if (this.frBlridCart === 2) { //如果是法人复印件
        if (!this.formData.legalCopyFileId) {
          this.$Toast('请上传法人身份证复印件')
          return
        }
        this.formData.legalFrontFileId = ''
        this.formData.legalBackFileId = ''
      }
      if (!this.formData.holderData.holderName || !this.formData.holderData.holderId) {
        this.$Toast('请选择持有人！')
        return
      }
      if (!this.formData.holderData.signetTypeName || !this.formData.holderData.signetType) {
        this.$Toast('请选择印章类型！')
        return
      }
      if (!this.formData.holderData.signetName || !this.formData.holderData.signetId) {
        this.$Toast('请选择印章名称！')
        return
      }
      return true
    },
    onSubmit() { //提交
      const that = this
      const result = this.onCheck()
      if (!result) {
        return
      }
      const params = JSON.parse(JSON.stringify(this.formData))
      params.items = [params.holderData]
      delete params.holderData
      let url = ''
      switch (this.formData.applyType) {
        case 0: //新办
          url = '/cert/api/newCertApply'
          break
        case 2: //续签
          url = '/cert/api/renewCertApply'
          break
        case 1: //变更
          url = '/cert/api/changCertApply'
          break
        case 3: //补办
          url = '/cert/api/supplCertApply'
          break
        case 4: //注销
          url = '/cert/api/cancelCertApply'
          break
      }
      Dialog.confirm({
        title: '提示',
        message: '确定提交吗？',
        confirmButtonText: '确定',
        confirmButtonColor: '#0277FC'
      }).then(() => {
        that.$store.dispatch(this.$LoadShow, true)
        that.$post(url, params).then(rel => {
          if (rel.success) {
            that.$Toast('提交成功！')
            that.$router.push({
              name: 'corpCertApplySuccess',
            })
          } else {
            that.$Toast(rel.message || rel.messageDetail)
          }
        }).finally(() => {
          that.$store.dispatch(that.$LoadShow, false)
        })
      })
        .catch(() => {
          // on cancel
        });
    },
  },

  beforeDestroy() {
    //自动回收
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/global.css";

::v-deep .van-image__img {
  object-fit: contain !important;
}

::v-deep .van-cell {
  padding: .5rem .2rem;
}

.corp-cert-apply {
  .all_tips_red_after {
    font-size: .7rem;
    color: #666;
  }

  .all_van_field {
    font-size: .7rem;

    &:focus-within {
      border-bottom: 1px solid rgba(81, 104, 244, 1) !important;
    }
  }

  ::v-deep .van-radio-group {
    padding: .5rem .2rem;

    .van-radio {
      display: inline-block;
      font-size: .7rem;
      color: #666;

      &:last-of-type {
        margin-left: 1rem;
      }
    }

    .van-radio__icon {
      display: inline-block;
    }
  }
  .tip{
    margin-top:.5rem;
    word-break: break-all;
    color: #333;
    text-align: center;
  }
}


.cancel-btn {
  font-size: .7rem;
  text-align: center;
  height: 2.4rem;
  line-height: 2.4rem;
  color: #999;
  border-top: 1px solid #ccc;
}

.popup-list-box {
  max-height: 20rem;
  overflow: hidden;
  display: flex;
  flex-flow: column;

  .popup-list-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .popup-list-title {
    text-align: center;
    padding: .5rem;
  }

  .popup-list-item {
    padding: .6rem;

    div {
      word-break: break-all;
    }
  }
}
</style>
